<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addNewKind">新增分组</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="分组名称" prop="GROUP_NAME"></el-table-column>
          <el-table-column label="简称" prop="ALIAS_NAME"></el-table-column>
          <el-table-column label="操作" min-width="50px">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="skuProduct(scope.row)">查看</el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" @click="editProduct(scope.row)">修改
              </el-button>
              <el-button type="text" size="small" icon="el-icon-close" style="color: rgb(245, 108, 108)"
                @click="deleteProduct(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount"
          @current-change="handleCurrentChange">
        </el-pagination>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <!-- 增加分组 -->
        <el-dialog title="新增分组" center :visible.sync="addFormVisible" width="600px">
          <el-form size="small" :model="addForm" ref="addForm">
            <el-form-item label="分组名称：" :label-width="formLabelWidth">
              <el-input v-model="addForm.Name"></el-input>
            </el-form-item>
            <el-form-item label="分组简称：" :label-width="formLabelWidth">
              <el-input v-model="addForm.ALIAS_NAME"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitAdd" v-if="this.addForm.Name === ''" disabled>确 定</el-button>
            <el-button size="small" @click="submitAdd" v-else>确 定</el-button>
          </div>
        </el-dialog>
        <!-- 修改模态框 -->
        <el-dialog title="修改品类" center :visible.sync="editFormVisible" width="600px">
          <el-form size="small" :model="editForm" ref="editForm">
            <el-form-item label="分组名称：" :label-width="formLabelWidth">
              <el-input v-model="editForm.GROUP_NAME"></el-input>
            </el-form-item>
            <el-form-item label="分组简称：" :label-width="formLabelWidth">
              <el-input v-model="editForm.ALIAS_NAME"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitEdit">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  addGroupFun, deleteGroupFun, updateGroupFun, queryGroupFun,
} from 'api/systemSetting';

export default {
  data() {
    return {
      tableData: [],
      addForm: {
        Name: '',
      },
      // loading: false,
      addFormVisible: false,
      formLabelWidth: '120px',
      editForm: {},
      editFormVisible: false,
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
  methods: {
    addNewKind() {
      this.addFormVisible = true;
    },
    editProduct(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    skuProduct(row) {
      this.$router.push({ name: 'matchGroup' });
      sessionStorage.setItem('kindId', row.ID);
    },
    // --------------------------添加分组
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            GROUP_NAME: this.addForm.Name,
            ALIAS_NAME: this.addForm.ALIAS_NAME,
          };
          addGroupFun(params).then((result) => {
            this.$message.show({ text: '新增品类成功', type: 'success' });
            this.addFormVisible = false;
            this.addForm = {};
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // ------------------------------------删除功能
    deleteProduct(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            GROUP_ID: row.ID,
          };
          deleteGroupFun(params).then((result) => {
            this.$message.show({ text: '删除品类成功', type: 'success' });
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // -----------------------------------修改功能
    submitEdit() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            GROUP_ID: this.editForm.ID,
            ALIAS_NAME: this.editForm.ALIAS_NAME,
            GROUP_NAME: this.editForm.GROUP_NAME,
          };
          updateGroupFun(params)
            .then((result) => {
              this.$message.show({ text: '修改品类成功', type: 'success' });
              this.editFormVisible = false;
              this.editForm = {};
              this.queryTable();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {}
      }
    },
    close() {
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.addForm = {};
    },
    // -----------------------------------进入页面拉取数据
    queryTable() {
      queryGroupFun().then((result) => {
        this.tableData = result[0].OP_ROLE.length > 0 ? result[0].OP_ROLE : [];
        this.totalCount = result[0].TOTAL_COUNT;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange() {
      this.queryTable();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/systemSetting/groupManage.vue